import { render, staticRenderFns } from "./CreateLogisticsLeadTimeFromProposedLeadTime.vue?vue&type=template&id=47894f62&scoped=true&"
import script from "./CreateLogisticsLeadTimeFromProposedLeadTime.vue?vue&type=script&lang=js&"
export * from "./CreateLogisticsLeadTimeFromProposedLeadTime.vue?vue&type=script&lang=js&"
import style0 from "./CreateLogisticsLeadTimeFromProposedLeadTime.vue?vue&type=style&index=0&id=47894f62&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47894f62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCol,VContainer,VDialog,VForm,VRow})
